// extracted by mini-css-extract-plugin
export default {"CSSThemeProvider":"Theme_CSSThemeProvider__7N3cj"};